module.exports = ".container {\n  padding: 20px;\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examination/summary/summary.component.scss
// module id = ./src/app/examination/summary/summary.component.scss
// module chunks = main